import { employeeNameSort, formatMfaStatusType, getAutheticationTypeFormatter } from './table.util'

const getMfaConfiguration = (item, intl) => {
  const configurationStatus = item?.mfaConfigurations?.configurationStatus
  const numberCaPolicies = item?.mfaConfigurations?.affectedByCAs?.length

  const configurationStatusMessage = configurationStatus
    ? intl.formatMessage({ id: `INTEGRATION.${configurationStatus}` })
    : ''
  const isAffectedByCAs = ['CAP', 'DUO', 'DUO_AND_CAP'].includes(configurationStatus)
  const numberCaPoliciesMessage = `${numberCaPolicies} ${intl.formatMessage({
    id: 'INTEGRATION.CONDITIONALPOLICY',
  })}`

  return `${configurationStatusMessage} ${isAffectedByCAs ? '/' : ''} ${
    isAffectedByCAs ? numberCaPoliciesMessage : ''
  }`.trim()
}

const getMfaStatus = (item, intl) => {
  const mfaStatus = item?.mfaStatus?.status
  const mfaStatusMessage = mfaStatus ? intl.formatMessage({ id: `INTEGRATION.${mfaStatus}` }) : ''

  const statusList = item.mfaStatus?.statusList ?? []
  const statusListMessage = statusList
    .map((obj) =>
      `${formatMfaStatusType(obj.type, intl)} ${obj.status ? '-' : ''} ${
        obj.status ? intl.formatMessage({ id: `GENERAL.${obj.status}` }) : ''
      }`.trim(),
    )
    .join(', ')

  return `${mfaStatusMessage} ${statusListMessage ? '/' : ''} ${statusListMessage}`.trim()
}

const formatMfaReportData = ({ employees }, { order }, intl) =>
  employees
    .sort((a, b) => employeeNameSort(a, b, order, undefined, a, b))
    .map(({ email, licenseType, role, ...item }) => ({
      email,
      licenseType,
      role,
      name: item.displayName || `${item.firstName} ${item.lastName}`,
      mfaConfiguration: getMfaConfiguration(item, intl),
      mfaStatus: getMfaStatus(item, intl),
      authenticationType: item.authenticationType?.map(getAutheticationTypeFormatter(intl)).join(', '),
    }))

export default {
  MFA_REPORT: formatMfaReportData,
}
